











































import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component
export default class Filters extends Vue {

  @Prop({ required: true, type: Boolean })
  show!: boolean

  @Prop({ required: true, type: Object })
  value: any = {}

  filter = {
    categorie: [0, 1],
    fPrice: [0, 5000]
  };

  @Watch("value")
  ff(parentVal: Object) {
    console.log("valued;sdds;dajdjad;lj;sd", arguments)
  }


  onClose() {
    this.$emit("input", { ...this.filter })
  }
}
